(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('fileUploadService', fileUploadService);

	function fileUploadService($q, $http, $rootScope, $timeout, _, $, fileMapper, dateTimeUtility, assetCommonConfig) {

		function uploadFileAsync(file, cancellationToken) {
			var deferred = $q.defer();

			var form = new FormData();
			form.append('file', file);
			form.append('lastModified', dateTimeUtility.toIso8601(file.lastModifiedDate));

			var updateProgressSoon = _.throttle(function (e) {
				if (e.lengthComputable)
					deferred.notify({ loaded: e.loaded, total: e.total });
			}, 50);

			// Angular's $http service makes it difficult to use FormData and progress events
			var jqXhr = $.ajax({
				url: assetCommonConfig.assetServiceBaseUri + 'files',
				type: 'POST',
				processData: false,
				contentType: false,
				data: form,
				xhr: function () {
					var xhr = $.ajaxSettings.xhr();
					if (xhr.upload)
						xhr.upload.addEventListener('progress', updateProgressSoon, false);

					return xhr;
				}
			})
			.success(function (result) {
				deferred.resolve(fileMapper.map(result));
			})
			.error(function (jqXhr, status, error) {
				deferred.reject(error);
			})
			.complete(function () {
				$rootScope.$digest();
			});

			if (cancellationToken) {
				cancellationToken.whenCanceled(function () {
					$timeout(function () {
						jqXhr.abort();
					}, 0, false);
				});
			}

			return deferred.promise;
		}

		function getFileBatchUploadIdAsync() {
			return $http.get(assetCommonConfig.assetServiceBaseUri + 'newids?count=1')
				.then(function (result) {
					return result.data.ids[0];
				});
		}

		return Object.freeze({
			uploadFileAsync: uploadFileAsync,
			getFileBatchUploadIdAsync: getFileBatchUploadIdAsync
		});
	}
	fileUploadService.$inject = ['$q', '$http', '$rootScope', '$timeout', '_', '$', 'fileMapper', 'dateTimeUtility', 'assetCommonConfig'];
})();